export const BOOKING_STATUS = [
  { value: 1, label: 'Mới', color: 'blue' },
  { value: 2, label: 'Thành công', color: 'green' },
  { value: 3, label: 'Thất bại', color: 'red' }
]

export const BOOKING_TYPE = [
  { value: 1, label: 'Dẫn khách' },
  { value: 2, label: 'Thông tin' }
]

